import { axios } from "../axios.instance";

export type ProcessPaymentNMIRequest = { orderId: string; paymentToken: string };

export type ProcessPaymentNMIResponse = {
  id: string;
};

export const processPaymentNMI = async (body: ProcessPaymentNMIRequest): Promise<ProcessPaymentNMIResponse> => {
  const { data } = await axios.post(`/payments/nmi/process`, body);

  return data;
};
